import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { VisitasApiService } from '../../../../../service/api/visitas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { build, pool } from '../../../../../common/classes/request-builder';

import { TrasiegoModel } from 'src/app/models/visitas/trasiego.model';
import { VisitasTrasiegoFormDefinition } from './form-control/form-definition';
import type {
    ReactiveFormChangedField,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-visitas-trasiego-form',
    standalone: false,
    templateUrl: './visitas-trasiego-form.component.html',
    styleUrls: ['./visitas-trasiego-form.component.scss']
})
export class VisitasTrasiegoFormComponent extends BaseForm<TrasiegoModel> implements OnInit {
    public override model: TrasiegoModel = { semana: 0 };

    public form!: VisitasTrasiegoFormDefinition;

    public formReady = false;

    private readonly showVisitasTrasiego10Plagas = Boolean(environment.features.showVisitasTrasiento10Plagas);

    public constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public visitasApi: VisitasApiService,
        public fincasApi: FincasApiService,
        public formApi: FormCommonApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            visitasApi.visitasTrasiego.PUT,
            visitasApi.visitasTrasiego.POST,
            'visitas-trasiego',
            'Actualizar Visita',
            'Crear Visita',
        );
    }// constructor();

    public ngOnInit(): void {
        this.form = new VisitasTrasiegoFormDefinition(
            this.getType(),
            this.model,
            null,
            this.showVisitasTrasiego10Plagas,
        );

        this.initFormData()
            .then(() => {
                this.softInit(this.getType());
                this.formReady = true;
                return;
            })
            .catch((error: unknown) => {
                console.error('Error loading trap visit form data:', error);
                this.softInit(this.getType());
                this.formReady = true;
            });
    }// ngOnInit();

    public reactiveFormChanges(
        formModel: ReactiveFormValue<TrasiegoModel>,
        lastChangedFieldName: ReactiveFormChangedField<TrasiegoModel>,
    ): void {
        this.form.updateModel(formModel, lastChangedFieldName);
        this.model = this.form.model as TrasiegoModel;

        if (lastChangedFieldName === '__previous_data_patch' || lastChangedFieldName === '__dropdown_refresh') {
            this.applyLoadedReactiveState(lastChangedFieldName);
            return;
        }// if();

        this.formChanges(String(lastChangedFieldName ?? ''));
        this.formBuilderRef?.updateForm(this.form.model as Record<string, unknown>, false);
    }// reactiveFormChanges();

    public formChanges(_tag: string): void {
        this.finalizeExternalDropdowns();
        this.dropdownLoadTrigger.next();
    }// formChanges();

    private initFormData(): Promise<boolean> {
        return pool([
            build(this.fincasApi.fincasGET, this.form.lists.fincas, 'nombre'),
            build(this.fincasApi.parcelasGET, this.form.lists.parcelas, 'nombre', true),
        ], () => {
            this.finalizeExternalDropdowns();
            this.dropdownLoadTrigger.next();
        }).then(() => true);
    }// initFormData();

    private applyLoadedReactiveState(lastChangedFieldName: ReactiveFormChangedField<TrasiegoModel>): void {
        this.form.updateModel(this.model as ReactiveFormValue<TrasiegoModel>, lastChangedFieldName);
        this.model = this.form.model as TrasiegoModel;
        this.formBuilderRef?.updateForm(this.form.model as Record<string, unknown>, false);
        this.finalizeExternalDropdowns();
        this.dropdownLoadTrigger.next();
    }// applyLoadedReactiveState();
}
